class DropdownMenu {
  constructor() {
    this.parentLinkLi = document.querySelectorAll(
      ".site-header__main-nav li.menu-item-has-children",
    );
    this.events();
  }

  events() {
    if (window.screen.width > 767) {
      this.parentLinkLi.forEach(link => {
        const anchorToggle = link.querySelector("a");
        const btn =
          '<button><span><span class="visually-hidden">show submenu for “' +
          anchorToggle.innerHTML +
          "”</span></span></button>";

        anchorToggle.insertAdjacentHTML("afterend", btn);
        this.handleButton(link);
      });
    }
  }

 handleButton(link) {
    link.querySelector("button").addEventListener("click", function (e) {
      if (this.parentNode.className == ".menu-item-has-children") {
        this.parentNode.className = ".menu-item-has-children menu-active";
        this.parentNode
          .querySelector("a")
          .setAttribute("aria-expanded", "true");
        this.parentNode
          .querySelector("button")
          .setAttribute("aria-expanded", "true");
      } else {
        this.parentNode.className = ".menu-item-has-children";
        this.parentNode
          .querySelector("a")
          .setAttribute("aria-expanded", "false");
        this.parentNode
          .querySelector("button")
          .setAttribute("aria-expanded", "false");
      }
      e.preventDefault();
    });
  }
}

export default DropdownMenu;
